module.exports = __webpack_public_path__ + "static/media/logo.14f6852a.png";